import { styled, TextField } from '@mui/material';
import type { SxProps, Theme } from '@mui/material/styles';

interface TextInputProps {
  name: string;
  label?: string;
  placeholder?: string;
  value: string;
  required?: boolean;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  error: boolean | undefined;
  size?: 'small' | 'large';
  style?: SxProps<Theme>;
  startAdornment?: React.ReactNode;
}

const MUI_SIZE = { small: 'small', large: 'medium' } as const;

const SIZE_STYLES: Record<'small' | 'large', SxProps<Theme>> = {
  large: {},
  small: {
    '& .MuiOutlinedInput-root': { borderRadius: '8px' },
    '& .MuiInputBase-input': { fontSize: '14px' }
  }
};

export const StyledTextField = styled(TextField)(({ theme }) => ({
  '& .MuiInputLabel-root': {
    color: theme.palette.text.primary,
  },
  '& .MuiInputBase-input::placeholder': {
    opacity: 1,
    color: theme.palette.text.secondary,
  },
  '& .MuiOutlinedInput-root': {
    borderRadius: '10px',
    backgroundColor: '#FFF',
    '& fieldset': {
      borderColor: '#2B455E3B',
    },
    '&:hover fieldset': {
      borderColor: '#B2BAC2',
    },
    '&.Mui-focused fieldset': {
      borderColor: theme.palette.text.primary,
    },
  },
}));

const TextInput = ({
  name,
  label,
  placeholder = '',
  value,
  required = false,
  onChange,
  error,
  size = 'large',
  style,
  startAdornment,
}: TextInputProps) => {
  return (
    <StyledTextField
      name={name}
      label={label}
      placeholder={placeholder}
      value={value}
      required={required}
      error={error}
      onChange={onChange}
      size={MUI_SIZE[size]}
      fullWidth
      sx={[SIZE_STYLES[size], ...(Array.isArray(style) ? style : [style])]}
      slotProps={{
        inputLabel: {
          shrink: true
        },
        input: {
          startAdornment
        }
      }}
    />
  );
};

export default TextInput;